<app-authentication-container>
  <app-merchant-user-registration-form
    *ngIf="merchantId"
    [merchantId]="merchantId"
    [errorResponse]="errorResponse$ | async"
    [isLoading]="isLoading$ | async"
    (continue)="onContinue($event)"
  ></app-merchant-user-registration-form>
</app-authentication-container>
